import { UclThemeProvider } from "src/components/ucl-theme-provider";
import fceLogo from "../../assets/FordCredit_White_v3.svg";
import clock from "../../assets/clock.svg";
import { useTranslation } from "react-i18next";
import { Text } from "@ucl/dse/text";
import { LinkButton } from "src/components/link-button/link-button";
import styles from "./maintenance-page.module.scss";

export function MaintenancePage() {
    const { t } = useTranslation();

    const promotions = t("creditDecision.links.promotions", { returnObjects: true }) as {
        url: string;
        openNewTab: boolean;
    };

    return (
        <UclThemeProvider>
            <div id="maintenance div" className={styles.maintenancePage} data-testid={"maintenance-screen"}>
                <div className={styles.contentWrapper}>
                    <div className={styles.logoContainer}>
                        <img src={fceLogo} alt="Ford Credit Logo" />
                    </div>
                    <div className={styles.card}>
                        <img alt="" src={clock} className={styles.clockIcon} />
                        <Text.H3>{t("maintenance.title")}</Text.H3>
                        <Text.P>{t("maintenance.body")}</Text.P>
                        <Text.P>{t("maintenance.tryAgain")}</Text.P>
                        <Text.H3 className={styles.promptHeading}>{t("maintenance.prompt")}</Text.H3>
                        <Text.P>{t("maintenance.promotions")}</Text.P>
                        <div className={styles.buttonContainer}>
                            <LinkButton config={promotions}> {t("maintenance.explorePromotionsButton")} </LinkButton>
                        </div>
                    </div>
                </div>
            </div>
        </UclThemeProvider>
    );
}
